"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = '5.0.31';
//# sourceMappingURL=version.js.map